import { useQuery } from '@tanstack/react-query'
import { baseAPICall } from 'services/baseAPICall'
import { clientInstance } from 'utils/http-client'

export interface CampaignStatsResponse {
  total_campaigns: number
  sent_this_week: number
  active_campaigns: number
  replies_this_week: number
  avg_interested_rate: number | null
}

async function getCampaignStats(signal?: AbortSignal) {
  return baseAPICall<CampaignStatsResponse>(() =>
    clientInstance.get('contacts/campaigns/stats/', { signal })
  )
}

export const CAMPAIGN_STATS_QUERY_KEY = ['campaign-stats'] as const

export const useGetCampaignStats = (enabled = true) =>
  useQuery({
    queryKey: CAMPAIGN_STATS_QUERY_KEY,
    queryFn: ({ signal }) => getCampaignStats(signal),
    enabled,
    staleTime: 1000 * 60, // 1 minute
  })
